import { useEffect, useState } from "react";
// import WebsiteLiveModal from "../../Modal/WebsiteLiveModal";
import { lazy } from "react";
// import { useDispatch, useSelector } from "react-redux";
import "./Profile.scss";
import Info from "./components/Info";
import Website from "./components/Website";
import Bank from "./components/Bank";
import Logout from "./components/Logout";
import ChangeLanguage from "./components/ChangeLanguage";
import ChangePassword from "./components/ChangePassword";
import { getProfileData, getStorageValue } from "../../service/shared.service";
import httpApiCall from "../../service/api.service";
import toastr from "../elements/toast";
import { useDispatch } from "react-redux";
import { savePartnerProfileData } from "../../Redux/Slices/MainSlice";

const toastrService = new toastr(true);
const WebsiteLiveModal = lazy(() => import("../../Modal/WebsiteLiveModal"));

const ProfileComponent = () => {
  const partnerInfo = getStorageValue("partnerData")
  const [show, setShow] = useState(false);
  const [Tabs, setTabs] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const [profileData, setProfileData] = useState({
    AllData: "",
    country_currency_info: "",
    partner_profile: "",
    popups: "",
    stripe_data: "",
    partner_domains: [],
  });
  const dispatch = useDispatch();
  const tabsData = [
    "General Information",
    "Bank Information",
    "Personalized Website",
    "Change Password",
    "Logout",
  ];

  useEffect(() => {
    const storedTabs = sessionStorage.getItem("Tabs");
    const storedActiveTab = sessionStorage.getItem("activeTab");

    setTabs(storedTabs ? JSON.parse(storedTabs) : partnerInfo?.user_partner_info?.pu_id ? 3 : 0);
    setActiveTab(storedActiveTab ? JSON.parse(storedActiveTab):  partnerInfo?.user_partner_info?.pu_id ? 3 : 0);

    const callApi = async () => {
      const data = await getProfileData();
      if (data && data.is_error == 0) {
        dispatch(
          savePartnerProfileData({
            AllData: data,
            country_currency_info: data.country_currency_info,
            partner_profile: data.partner_profile,
            popups: data.popups,
            stripe_data: data.stripe_data,
            partner_domains: data.partner_domains,
            partner_events: data.partner_events,
          })
        );
        setProfileData((profile) => ({
          ...profile,
          AllData: data,
          country_currency_info: data.country_currency_info,
          partner_profile: data.partner_profile,
          popups: data.popups,
          stripe_data: data.stripe_data,
          partner_domains: data.partner_domains,
        }));
      } else {
        toastrService.showError(data?.original_text || data?.err);
      }
    };
    callApi();

    // Unmount
    return () => {
      sessionStorage.removeItem("Tabs");
      sessionStorage.removeItem("activeTab");
    };
  }, []);

  useEffect(() => {
    sessionStorage.setItem("Tabs", JSON.stringify(Tabs));
    sessionStorage.setItem("activeTab", JSON.stringify(activeTab));
  }, [Tabs, activeTab]);

  const handleTabClick = async (index: any) => {
    if (index == 4) {
      setShow(true);
      return;
    }
    setActiveTab(index);
    setTabs(index);
  };

  return (
    <div className="profile_component">
      <div className="profile-tabs--wrapper">
        <div className="profile--wrapper">
          <div className="row m-0">
            <div className="col-12 col-lg-3 col-xxl-2">
              <div className="profile-left">
                <div className="profile-header"></div>
                <div className="profile-tabs">
                  <ul id="prof-tabs">
                    {tabsData.map((item: any, index: any) => {
                      return (
                        partnerInfo?.user_partner_info?.pu_id && (index == 3 || index == 4) ? (
                          <li
                            key={index}
                            className={activeTab === index ? "active" : ""}
                            onClick={() => handleTabClick(index)}
                            id={`tabs-${index}`}
                          >
                            {item}
                          </li>
                        ) :
                        !partnerInfo?.user_partner_info?.pu_id && 
                        <li
                        key={index}
                        className={activeTab === index ? "active" : ""}
                        onClick={() => handleTabClick(index)}
                        id={`tabs-${index}`}
    
                      >
                        {item}
                      </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
            {/* {spinner &&  */}
            <div className=" col-12 col-lg-9 col-xxl-10 p-0">
              <div className="profile-right">
                {Tabs == 0 && <Info />}
                {Tabs == 1 && <Bank />}
                {Tabs == 2 && (
                  <Website partner_domains={profileData.partner_domains} />
                )}
                {Tabs == 3 && <ChangePassword />}
                {Tabs == 4 && <ChangeLanguage />}
                {show && <Logout show={show} onHide={() => setShow(false)} />}
              </div>
            </div>
            {/* } */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileComponent;
